<script setup>
import { computed, onBeforeUnmount } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { usePointsStore } from '@/stores/points'

const translaterStore = useTranslaterStore()
const pointsStore = usePointsStore()

const getTranslate = computed(() => translaterStore.getTranslate)
const connectionType = computed(() => pointsStore.connectionType)

const localType = computed(() => {
    let cType = 'CONNECTION_OFF'
    switch(connectionType.value.type) {
        case 76:
            cType = 'CONNECTION_LTE'
            break
        case 60:
            cType = 'CONNECTION_UMTS'
            break
        case 44:
            cType = 'CONNECTION_GSM'
            break
    }
    return cType
})

const connectionLevel = computed(() => {
    return typeof connectionType.value.level == 'number' ?
        connectionType.value.level : 
        null
    }
)

onBeforeUnmount(() => {
    pointsStore.resetConnectionType()
})
</script>

<template>
    <div class="uta-connection-type">
        <span class="uta-connection-type__type">
            {{ getTranslate[localType] || localType }}
        </span>
        <span class="uta-connection-type__level" v-if="connectionLevel">
            [{{ connectionLevel }} dBm]
        </span>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/connection-type.scss';
</style>